import axios from 'axios'
import { PANELCHANGER_BASEURL } from '../constants/system'
import * as AT from '../constants/actionTypes'
import { history } from '../store'

/**
 * Common URL fetcher based on Axios. Base URL loaded from external resource.
 * @param {*} url 
 * @param {*} method 
 * @param {*} data 
 * @param {*} actionCreatorFinished 
 * @param {*} actionCreatorFailed 
 * @param {*} dispatch 
 */
export function CommonFetcher(urlPath, method, data, actionCreatorFinished, actionCreatorFailed, dispatch) {
	console.log('URL: ' + PANELCHANGER_BASEURL + urlPath);
	return axios({
		url: PANELCHANGER_BASEURL + urlPath,
		headers: {
			'Token': localStorage.getItem('token')
		},
		data,
		method,
		timeout: 20000,
		type: 'json'
	})
		.then(function (response) {
			dispatch(actionCreatorFinished(response.data));
		})
		.catch(function (error) {
			console.log(error);
			if (error.response) {
				if (error.response.status === 401) // Unauthorized
				{
					dispatch(actionCreatorFailed(error.response.data.toString(), error.response.status));
				}
				else if (error.response.status === 403) // Forbidden
				{
					dispatch(actionCreatorFailed(error.response.data.toString(), error.response.status));
				}
				else if (error.response.status === 406) // Special BI error
				{
					dispatch(actionCreatorFailed(error.response.data.errors[0].title));
				}
				else if (error.response.status === 400) {
					var errorMessage = '';

					if (error.response.data !== undefined && error.response.data.errors === undefined) {
						errorMessage = error.response.data
					}
					else if (error.response.data.errors !== undefined && error.response.data.errors.length > 0) 
					{
						for (var i = 0; i < error.response.data.errors.length; i++) {
							var errorDetails = error.response.data.errors[i];

							errorMessage += errorDetails.message + '. ';

							if (errorDetails.meta.form_errors !== undefined) {
								errorMessage += JSON.stringify(errorDetails.meta.form_errors);
							}
						}
					}
					else {
						errorMessage = error.message + ' (Status: ' + error.response.status + ')';
					}

					dispatch(actionCreatorFailed(errorMessage, error.response.status));
				}
				else {
					dispatch(actionCreatorFailed(error.message, error.response.status));
				}
			}
			else {
				dispatch(actionCreatorFailed(error.toString(), 'NO CONNECTION'));
			}
		})
}

/**
 * Common file uploader.
 */
export function FileUploader(urlPath, attachment, actionCreatorFinished, actionCreatorFailed, dispatch) {
	if (PANELCHANGER_BASEURL.startsWith('staging')) {
		console.log('WARNING! APP USES STAGING VARIABLES!');
	}

	var formData = new FormData();
	formData.append('attachment', attachment);

	return axios.post(PANELCHANGER_BASEURL + urlPath,
		formData,
		{
			headers: {
				'Token': localStorage.getItem('token'),
				'Content-Type': 'multipart/form-data'
			}
		})
		.then(function (response) {
			dispatch(actionCreatorFinished(response.data));
		})
		.catch(function (error) {
			console.log(error);
			if (error.response) {
				if (error.response.status === 401) // Unauthorized
				{
					dispatch(ProfileLogout());
				}
				else if (error.response.status === 403) // Forbidden
				{
					dispatch(actionCreatorFailed(error.response.data.toString()));
				}
				else if (error.response.status === 406) // Special BI error
				{
					dispatch(actionCreatorFailed(error.response.data.errors[0].title));
				}
				else if (error.response.status === 400) {
					var errorMessage = '';

					if (error.response.data !== undefined && error.response.data.errors === undefined) {
						errorMessage = error.response.data
					}
					else if (error.response.data.errors !== undefined && error.response.data.errors.length > 0)
					{
						for (var i = 0; i < error.response.data.errors.length; i++) {
							var errorDetails = error.response.data.errors[i];

							errorMessage += errorDetails.message + '. ';

							if (errorDetails.meta.form_errors !== undefined) {
								errorMessage += JSON.stringify(errorDetails.meta.form_errors);
							}
						}
					}
					else {
						errorMessage = error.message + ' (Status: ' + error.response.status + ')';
					}

					dispatch(actionCreatorFailed(errorMessage));
				}
				else {
					dispatch(actionCreatorFailed(error.message + ' (Status: ' + error.response.status + ')'));
				}
			}
			else {
				dispatch(actionCreatorFailed(error.toString()));
			}
		})
}

//
// Case attachment
//

export function UploadFileStarted(attachment) {
	return function (dispatch) {
		dispatch({
			type: AT.UPLOAD_FILE_STARTED
		});
		FileUploader('/import', attachment, UploadFileFinished, UploadFileFailed, dispatch);
	}
}

export function UploadFileFailed(error) {
	return {
		type: AT.UPLOAD_FILE_FAILED,
		payload: {
			error
		}
	}
}

export function UploadFileFinished(attachmentId) {
	return {
		type: AT.UPLOAD_FILE_FINISHED,
		payload: {
			attachmentId
		}
	}
}

//
// Panel
//

export function PanelLoadingStarted(visitorTerritory, detailed) {
	return function (dispatch) {
		dispatch({
			type: AT.PANEL_LOADING_STARTED
		});
		CommonFetcher('/panel/' + visitorTerritory + '/' + detailed, 'get', undefined, PanelLoadingFinished, PanelLoadingFailed, dispatch);
	}
}

export function PanelLoadingFailed(error) {
	return {
		type: AT.PANEL_LOADING_FAILED,
		payload: {
			error
		}
	}
}

export function PanelLoadingFinished(actualPanel) {
	return {
		type: AT.PANEL_LOADING_FINISHED,
		payload: {
			actualPanel
		}
	}
}

export function PanelForExportLoadingStarted(visitorTerritory) {
	return function (dispatch) {
		dispatch({
			type: AT.PANEL_FOR_EXPORT_LOADING_STARTED
		});
		CommonFetcher('/panel/' + visitorTerritory + '/detailed', 'get', undefined, PanelForExportLoadingFinished, PanelForExportLoadingFailed, dispatch);
	}
}

export function PanelForExportLoadingFailed(error) {
	return {
		type: AT.PANEL_FOR_EXPORT_LOADING_FAILED,
		payload: {
			error
		}
	}
}

export function PanelForExportLoadingFinished(actualPanel) {
	return {
		type: AT.PANEL_FOR_EXPORT_LOADING_FINISHED,
		payload: {
			actualPanel
		}
	}
}

export function PanelAllLoadingStarted(rsm) {
	return function (dispatch) {
		dispatch({
			type: AT.PANEL_ALL_LOADING_STARTED
		});
		CommonFetcher('/panels/' + rsm, 'get', undefined, PanelAllLoadingFinished, PanelAllLoadingFailed, dispatch);
	}
}

export function PanelAllLoadingFailed(error) {
	return {
		type: AT.PANEL_ALL_LOADING_FAILED,
		payload: {
			error
		}
	}
}

export function PanelAllLoadingFinished(allActualPanel) {
	return {
		type: AT.PANEL_ALL_LOADING_FINISHED,
		payload: {
			allActualPanel
		}
	}
}

//
// Target
//

export function TargetLoadingStarted(license) {
	return function (dispatch) {
		dispatch({
			type: AT.TARGET_LOADING_STARTED
		});
		CommonFetcher('/target/' + license, 'get', undefined, TargetLoadingFinished, TargetLoadingFailed, dispatch);
	}
}

export function TargetLoadingFailed(error) {
	return {
		type: AT.TARGET_LOADING_FAILED,
		payload: {
			error
		}
	}
}

export function TargetLoadingFinished(actualTarget) {
	return {
		type: AT.TARGET_LOADING_FINISHED,
		payload: {
			actualTarget
		}
	}
}

export function TargetListLoadingStarted(name) {
	return function (dispatch) {
		dispatch({
			type: AT.TARGET_LIST_LOADING_STARTED
		});
		CommonFetcher('/target/search/' + name, 'get', undefined, TargetListLoadingFinished, TargetListLoadingFailed, dispatch);
	}
}

export function TargetListLoadingFailed(error) {
	return {
		type: AT.TARGET_LIST_LOADING_FAILED,
		payload: {
			error
		}
	}
}

export function TargetListLoadingFinished(targets) {
	return {
		type: AT.TARGET_LIST_LOADING_FINISHED,
		payload: {
			targets
		}
	}
}

//
// Targetgroup
//

export function TargetGroupListLoadingStarted(name) {
	return function (dispatch) {
		dispatch({
			type: AT.TARGETGROUP_LIST_LOADING_STARTED
		});
		CommonFetcher('/targetgroup', 'get', undefined, TargetGroupListLoadingFinished, TargetGroupListLoadingFailed, dispatch);
	}
}

export function TargetGroupListLoadingFailed(error) {
	return {
		type: AT.TARGETGROUP_LIST_LOADING_FAILED,
		payload: {
			error
		}
	}
}

export function TargetGroupListLoadingFinished(targetgroups) {
	return {
		type: AT.TARGETGROUP_LIST_LOADING_FINISHED,
		payload: {
			targetgroups
		}
	}
}

//
// City
//

export function CityListLoadingStarted() {
	return function (dispatch) {
		dispatch({
			type: AT.CITY_LIST_LOADING_STARTED
		});
		CommonFetcher('/city', 'get', undefined, CityListLoadingFinished, CityListLoadingFailed, dispatch);
	}
}

export function CityListLoadingFailed(error) {
	return {
		type: AT.CITY_LIST_LOADING_FAILED,
		payload: {
			error
		}
	}
}

export function CityListLoadingFinished(cities) {
	return {
		type: AT.CITY_LIST_LOADING_FINISHED,
		payload: {
			cities
		}
	}
}

export function CityWithPostalCodeListLoadingStarted() {
	return function (dispatch) {
		dispatch({
			type: AT.CITY_WITH_POSTAL_CODE_LIST_LOADING_STARTED
		});
		CommonFetcher('/city/postalcode', 'get', undefined, CityWithPostalCodeListLoadingFinished, CityWithPostalCodeListLoadingFailed, dispatch);
	}
}

export function CityWithPostalCodeListLoadingFailed(error) {
	return {
		type: AT.CITY_WITH_POSTAL_CODE_LIST_LOADING_FAILED,
		payload: {
			error
		}
	}
}

export function CityWithPostalCodeListLoadingFinished(cities) {
	return {
		type: AT.CITY_WITH_POSTAL_CODE_LIST_LOADING_FINISHED,
		payload: {
			cities
		}
	}
}

// Load city2zip.json from public folder
export function CityZipDataLoadingStarted() {
	return function (dispatch) {
		dispatch({
			type: AT.CITY_ZIP_DATA_LOADING_STARTED
		});
		
		fetch('/city2zip.json')
			.then(response => {
				if (!response.ok) {
					throw new Error('Failed to load city2zip.json');
				}
				return response.json();
			})
			.then(data => {
				// Normalize Budapest districts: "Budapest 01. ker." -> "Budapest"
				const normalizedData = data.map(entry => ({
					...entry,
					city: entry.city.startsWith('Budapest ') ? 'Budapest' : entry.city
				}));
				dispatch(CityZipDataLoadingFinished(normalizedData));
			})
			.catch(error => {
				dispatch(CityZipDataLoadingFailed(error.toString()));
			});
	}
}

export function CityZipDataLoadingFailed(error) {
	return {
		type: AT.CITY_ZIP_DATA_LOADING_FAILED,
		payload: {
			error
		}
	}
}

export function CityZipDataLoadingFinished(cityZipData) {
	return {
		type: AT.CITY_ZIP_DATA_LOADING_FINISHED,
		payload: {
			cityZipData
		}
	}
}

//
// Reset
export function ResetAll() {
	return function (dispatch) {
		dispatch({
			type: AT.RESET_ALL
		});
	}
}

export function ClearRequestUi() {
	return {
		type: AT.REQUEST_UI_CLEAR
	};
}

export function ClearPanelChangeUi() {
	return {
		type: AT.PANELCHANGE_UI_CLEAR
	};
}

export function ClearPanelUi() {
	return {
		type: AT.PANEL_UI_CLEAR
	};
}

export function ClearTargetUi() {
	return {
		type: AT.TARGET_UI_CLEAR
	};
}

export function ClearTargetSearch() {
	return {
		type: AT.TARGET_SEARCH_CLEAR
	};
}

export function ClearAddressUi() {
	return {
		type: AT.ADDRESS_UI_CLEAR
	};
}

export function ClearSettingUi() {
	return {
		type: AT.SETTING_UI_CLEAR
	};
}

//
// User
//

export function UserListLoadingStarted(rsm) {
	return function (dispatch) {
		dispatch({
			type: AT.USER_LIST_LOADING_STARTED
		});
		CommonFetcher('/users/' + rsm, 'get', undefined, UserListLoadingFinished, UserListLoadingFailed, dispatch);
	}
}

export function UserListLoadingFailed(error) {
	return {
		type: AT.USER_LIST_LOADING_FAILED,
		payload: {
			error
		}
	}
}

export function UserListLoadingFinished(users) {
	return {
		type: AT.USER_LIST_LOADING_FINISHED,
		payload: {
			users
		}
	}
}

//
// Address
//

export function AddressListLoadingStarted(city, postalCode, address, hco) {
	console.log('Address list fetching started...');
	return function (dispatch) {
		dispatch({
			type: AT.ADDRESS_LIST_LOADING_STARTED
		});
		const url = '/address/search/' + (city === '' ? '*' : city) + '/' + (postalCode === '' ? '*' : postalCode) + '/' + (address === '' ? '*' : address) + '/' + (hco === '' ? '*' : hco);
		CommonFetcher(url, 'get', undefined, AddressListLoadingFinished, AddressListLoadingFailed, dispatch);
	}
}

export function AddressListLoadingFailed(error) {
	return {
		type: AT.ADDRESS_LIST_LOADING_FAILED,
		payload: {
			error
		}
	}
}

export function AddressListLoadingFinished(addresses) {
	return {
		type: AT.ADDRESS_LIST_LOADING_FINISHED,
		payload: {
			addresses
		}
	}
}

export function AddressListByLicenseLoadingStarted(license) {
	return function (dispatch) {
		dispatch({
			type: AT.ADDRESS_LIST_BY_LICENSE_LOADING_STARTED
		});
		CommonFetcher('/address/search/' + license, 'get', undefined, AddressListByLicenseLoadingFinished, AddressListByLicenseLoadingFailed, dispatch);
	}
}

export function AddressListByLicenseLoadingFailed(error) {
	return {
		type: AT.ADDRESS_LIST_BY_LICENSE_LOADING_FAILED,
		payload: {
			error
		}
	}
}

export function AddressListByLicenseLoadingFinished(addresses) {
	return {
		type: AT.ADDRESS_LIST_BY_LICENSE_LOADING_FINISHED,
		payload: {
			addresses
		}
	}
}

//
// Consent
//

export function GdprConsentByLicenseLoadingStarted(license) {
	return function (dispatch) {
		dispatch({
			type: AT.GDPR_CONSENT_BY_LICENSE_LOADING_STARTED
		});
		CommonFetcher('/gdpr/consent/' + license, 'get', undefined, GdprConsentByLicenseLoadingFinished, GdprConsentByLicenseLoadingFailed, dispatch);
	}
}

export function GdprConsentByLicenseLoadingFailed(error) {
	return {
		type: AT.GDPR_CONSENT_BY_LICENSE_LOADING_FAILED,
		payload: {
			error
		}
	}
}

export function GdprConsentByLicenseLoadingFinished(consent) {
	return {
		type: AT.GDPR_CONSENT_BY_LICENSE_LOADING_FINISHED,
		payload: {
			consent
		}
	}
}

export function GdprConsentByLicenseSavingStarted(license, status, reason, visitorTerritory) {
	return function (dispatch) {
		dispatch({
			type: AT.GDPR_CONSENT_BY_LICENSE_SAVING_STARTED
		});
		CommonFetcher('/gdpr/consent/' + license + '/' + status, 'post', { reason, visitorTerritory }, GdprConsentByLicenseSavingFinished, GdprConsentByLicenseSavingFailed, dispatch);
	}
}

export function GdprConsentByLicenseSavingFailed(error) {
	return {
		type: AT.GDPR_CONSENT_BY_LICENSE_SAVING_FAILED,
		payload: {
			error
		}
	}
}

export function GdprConsentByLicenseSavingFinished(newConsent) {
	return {
		type: AT.GDPR_CONSENT_BY_LICENSE_SAVING_FINISHED,
		payload: {
			newConsent
		}
	}
}

//
// Profile
//

export function ProfileLogout() {
	return function (dispatch) {
		dispatch({
			type: AT.PROFILE_LOGOUT
		});
	}
}

export function ProfileSessionExtended() {
	return {
		type: AT.PROFILE_SESSION_EXTENDED
	};
}

export function ProfileAutoLoginStarted(token) {
	// TODO
}

export function ProfileLoginMfaRequired(payload) {
	return {
		type: AT.PROFILE_LOGIN_MFA_REQUIRED,
		payload: { ticket: payload.ticket, username: payload.username }
	};
}

export function ProfileVerifyMfaStarted(ticket, code) {
	return function (dispatch) {
		dispatch({ type: AT.PROFILE_VERIFY_MFA_STARTED });
		axios({
			url: PANELCHANGER_BASEURL + '/login/verify-mfa',
			method: 'post',
			data: { ticket, code },
			timeout: 20000,
			headers: { 'Content-Type': 'application/json' }
		})
			.then(function (response) {
				dispatch(ProfileLoginFinished(response.data));
			})
			.catch(function (error) {
				const msg = error.response && error.response.status === 401
					? (error.response.data && typeof error.response.data === 'string' ? error.response.data : 'Érvénytelen vagy lejárt kód.')
					: (error.response && error.response.data ? (typeof error.response.data === 'string' ? error.response.data : (error.response.data.message || error.message)) : error.message);
				dispatch({
					type: AT.PROFILE_VERIFY_MFA_FAILED,
					payload: { error: msg }
				});
			});
	};
}

export function ProfileVerifyMfaFailed(error) {
	return { type: AT.PROFILE_VERIFY_MFA_FAILED, payload: { error } };
}

export function ProfileMfaCancelled() {
	return { type: AT.PROFILE_MFA_CANCELLED };
}

export function ProfileLoginStarted(username, password) {
	return function (dispatch) {
		dispatch({ type: AT.PROFILE_LOGIN_STARTED });
		axios({
			url: PANELCHANGER_BASEURL + '/login',
			method: 'post',
			data: { username, password },
			timeout: 20000,
			headers: { 'Content-Type': 'application/json' }
		})
			.then(function (response) {
				const data = response.data;
				if (data.mfaRequired === true && data.ticket) {
					dispatch(ProfileLoginMfaRequired({ ticket: data.ticket, username }));
				} else {
					dispatch(ProfileLoginFinished(data));
				}
			})
			.catch(function (error) {
				const data = error.response && error.response.data;
				const is403Expired = error.response && error.response.status === 403 && data && data.passwordExpired === true;
				if (is403Expired) {
					const token = data.token;
					const msg = data.message || 'A jelszó lejárt, kérjük állíts be újat.';
					if (token) {
						history.push('/reset-password?token=' + encodeURIComponent(token));
						dispatch(ProfileLoginFailed(msg));
					} else {
						dispatch(ProfileLoginFailed(msg + ' Kérd újra a jelszó-visszaállítási e-mailt az Elfelejtett jelszó menüpontból.'));
					}
					return;
				}
				const msg = data
					? (typeof data === 'string' ? data : (data.message || JSON.stringify(data)))
					: error.message;
				dispatch(ProfileLoginFailed(msg));
			});
	};
}

export function ProfileLoginFailed(error) {
	return {
		type: AT.PROFILE_LOGIN_FAILED,
		payload: {
			error
		}
	}
}

export function ProfileLoginFinished(profile) {
	return {
		type: AT.PROFILE_LOGIN_FINISHED,
		payload: {
			profile
		}
	}
}

//
// Panelchange
//

export function PanelChangeModifyTargetStarted(visitorTerritory, license, frequencyRequest, newsegmentation, newmypreferredspecialtyen, newmypreferredspecialtyhu) {
	return function (dispatch) {
		dispatch({
			type: AT.PANELCHANGE_MODIFY_TARGET_STARTED
		});
		CommonFetcher('/panelchange', 'post', { visitorTerritory, license, frequencyRequest, newsegmentation, newmypreferredspecialtyen, newmypreferredspecialtyhu, requestType: 'modify' }, PanelChangeAddTargetFinished, PanelChangeAddTargetFailed, dispatch);
	}
}

export function PanelChangeModifyTargetFailed(error) {
	return {
		type: AT.PANELCHANGE_MODIFY_TARGET_FAILED,
		payload: {
			error
		}
	}
}

export function PanelChangeModifyTargetFinished(newPanelChange) {
	return {
		type: AT.PANELCHANGE_MODIFY_TARGET_FINISHED,
		payload: {
			newPanelChange
		}
	}
}

export function PanelChangeAddTargetStarted(visitorTerritory, license, newsegmentation, newmypreferredspecialtyen, newmypreferredspecialtyhu, city, postalCode, address, veevaBrick) {
	return function (dispatch) {
		dispatch({
			type: AT.PANELCHANGE_ADD_TARGET_STARTED
		});
		CommonFetcher('/panelchange', 'post', { visitorTerritory, license, newsegmentation, newmypreferredspecialtyen, newmypreferredspecialtyhu, requestType: 'add', city, postalCode, address, veevaBrick }, PanelChangeAddTargetFinished, PanelChangeAddTargetFailed, dispatch);
	}
}

export function PanelChangeAddTargetFailed(error) {
	return {
		type: AT.PANELCHANGE_ADD_TARGET_FAILED,
		payload: {
			error
		}
	}
}

export function PanelChangeAddTargetFinished(newPanelChange) {
	return {
		type: AT.PANELCHANGE_ADD_TARGET_FINISHED,
		payload: {
			newPanelChange
		}
	}
}

export function PanelChangeRemoveTargetStarted(license, visitorTerritory) {
	return function (dispatch) {
		dispatch({
			type: AT.PANELCHANGE_REMOVE_TARGET_STARTED
		});
		CommonFetcher('/panelchange', 'post', { license, visitorTerritory, requestType: 'remove' }, PanelChangeRemoveTargetFinished, PanelChangeRemoveTargetFailed, dispatch);
	}
}

export function PanelChangeRemoveTargetFailed(error) {
	return {
		type: AT.PANELCHANGE_REMOVE_TARGET_FAILED,
		payload: {
			error
		}
	}
}

export function PanelChangeRemoveTargetFinished(newPanelChange) {
	return {
		type: AT.PANELCHANGE_REMOVE_TARGET_FINISHED,
		payload: {
			newPanelChange
		}
	}
}

export function PanelChangesLoadingStarted(visitorTerritory, detailed) {
	return function (dispatch) {
		dispatch({
			type: AT.PANELCHANGES_LIST_LOADING_STARTED
		});
		CommonFetcher('/panelChange/' + visitorTerritory + '/' + detailed, 'get', undefined, PanelChangesListLoadingFinished, PanelChangesListLoadingFailed, dispatch);
	}
}

export function PanelChangesListLoadingFailed(error) {
	return {
		type: AT.PANELCHANGES_LIST_LOADING_FAILED,
		payload: {
			error
		}
	}
}

export function PanelChangesListLoadingFinished(panelChanges) {
	return {
		type: AT.PANELCHANGES_LIST_LOADING_FINISHED,
		payload: {
			panelChanges
		}
	}
}

export function PanelChangesAllLoadingStarted(rsm) {
	return function (dispatch) {
		dispatch({
			type: AT.PANELCHANGES_ALL_LIST_LOADING_STARTED
		});
		CommonFetcher('/panelChanges/' + rsm, 'get', undefined, PanelChangesAllListLoadingFinished, PanelChangesAllListLoadingFailed, dispatch);
	}
}

export function PanelChangesAllListLoadingFailed(error) {
	return {
		type: AT.PANELCHANGES_ALL_LIST_LOADING_FAILED,
		payload: {
			error
		}
	}
}

export function PanelChangesAllListLoadingFinished(allPanelChanges) {
	return {
		type: AT.PANELCHANGES_ALL_LIST_LOADING_FINISHED,
		payload: {
			allPanelChanges
		}
	}
}

export function PanelChangeRemovingStarted(id) {
	return function (dispatch) {
		dispatch({
			type: AT.PANELCHANGE_REMOVING_STARTED
		});
		CommonFetcher('/panelChange/' + id, 'delete', undefined, PanelChangeRemovingFinished, PanelChangeRemovingFailed, dispatch);
	}
}

export function PanelChangeRemovingFailed(error) {
	return {
		type: AT.PANELCHANGE_REMOVING_FAILED,
		payload: {
			error
		}
	}
}

export function PanelChangeRemovingFinished(result) {
	return {
		type: AT.PANELCHANGE_REMOVING_FINISHED,
		payload: {
			id: result.id, 
			license: result.license
		}
	}
}

export function PanelChangesSetStatusStarted(id, status) {
	return function (dispatch) {
		dispatch({
			type: AT.PANELCHANGE_SETSTATUS_STARTED
		});
		CommonFetcher('/panelChange/' + id + '/' + status, 'post', undefined, PanelChangesSetStatusFinished, PanelChangesSetStatusFailed, dispatch);
	}
}

export function PanelChangesSetStatusFailed(error) {
	return {
		type: AT.PANELCHANGE_SETSTATUS_FAILED,
		payload: {
			error
		}
	}
}

export function PanelChangesSetStatusFinished(result) {
	return {
		type: AT.PANELCHANGE_SETSTATUS_FINISHED,
		payload: {
			id: result.id,
			status: result.status
		}
	}
}

//
// Request
//

export function RequestAddNewAddressStarted(visitorTerritory, license, city, postalCode, address, hco) {
	return function (dispatch) {
		dispatch({
			type: AT.REQUEST_ADD_NEW_ADDRESS_STARTED
		});
		//CommonFetcher('/panel/' + visitorTerritory + '/' + license + '/' + city + '/' + postalCode + '/' + address, 'post', undefined, AddAddressToPanelFinished, AddAddressToPanelFailed, dispatch);
		CommonFetcher('/request/', 'post', { requestType: 'address', isExistingRecord: false, visitorTerritory, license, city, postalCode, address, hco }, RequestAddNewAddressFinished, RequestAddNewAddressFailed, dispatch);
	}
}

export function RequestAddNewAddressFailed(error) {
	return {
		type: AT.REQUEST_ADD_NEW_ADDRESS_FAILED,
		payload: {
			error
		}
	}
}

export function RequestAddNewAddressFinished(newRequest) {
	return {
		type: AT.REQUEST_ADD_NEW_ADDRESS_FINISHED,
		payload: {
			newRequest
		}
	}
}

export function RequestCheckLicenseStarted(license) {
	return function (dispatch) {
		dispatch({
			type: AT.REQUEST_CHECK_LICENSE_STARTED
		});
		CommonFetcher('/request/' + license, 'post', undefined, RequestCheckLicenseFinished, RequestCheckLicenseFailed, dispatch);
	}
}

export function RequestCheckLicenseFailed(error) {
	return {
		type: AT.REQUEST_CHECK_LICENSE_FAILED,
		payload: {
			license: error.license,
			name: error.name
		}
	}
}

export function RequestCheckLicenseFinished(license) {
	return {
		type: AT.REQUEST_CHECK_LICENSE_FINISHED,
		payload: {
			license
		}
	}
}

export function RequestAddNewTargetStarted(visitorTerritory, stamp, name, segmentation, mypreferredspecialtyen, mypreferredspecialtyhu, city, postalCode, address, hco) {
	return function (dispatch) {
		dispatch({
			type: AT.REQUEST_ADD_NEW_TARGET_STARTED
		});
		//CommonFetcher('/panel/' + visitorTerritory + '/' + license + '/' + city + '/' + postalCode + '/' + address, 'post', undefined, AddAddressToPanelFinished, AddAddressToPanelFailed, dispatch);
		CommonFetcher('/request/', 'post', { requestType: 'target', isExistingRecord: false, visitorTerritory, stamp, name, segmentation, mypreferredspecialtyen, mypreferredspecialtyhu, city, postalCode, address, hco }, RequestAddNewTargetFinished, RequestAddNewTargetFailed, dispatch);
	}
}

export function RequestAddNewTargetFailed(error) {
	return {
		type: AT.REQUEST_ADD_NEW_TARGET_FAILED,
		payload: {
			error
		}
	}
}

export function RequestAddNewTargetFinished(newRequest) {
	return {
		type: AT.REQUEST_ADD_NEW_TARGET_FINISHED,
		payload: {
			newRequest
		}
	}
}

export function RequestAddExistingAddressStarted(visitorTerritory, license, city, postalCode, address, hco) {
	return function (dispatch) {
		dispatch({
			type: AT.REQUEST_ADD_EXISTING_ADDRESS_STARTED
		});
		//CommonFetcher('/panel/' + visitorTerritory + '/' + license + '/' + city + '/' + postalCode + '/' + address, 'post', undefined, AddAddressToPanelFinished, AddAddressToPanelFailed, dispatch);
		CommonFetcher('/request/', 'post', { requestType: 'address', isExistingRecord: true, visitorTerritory, license, city, postalCode, address, hco }, RequestAddExistingAddressFinished, RequestAddExistingAddressFailed, dispatch);
	}
}

export function RequestAddExistingAddressFailed(error) {
	return {
		type: AT.REQUEST_ADD_EXISTING_ADDRESS_FAILED,
		payload: {
			error
		}
	}
}

export function RequestAddExistingAddressFinished(newRequest) {
	return {
		type: AT.REQUEST_ADD_EXISTING_ADDRESS_FINISHED,
		payload: {
			newRequest
		}
	}
}

export function RequestsLoadingStarted(visitorTerritory) {
	return function (dispatch) {
		dispatch({
			type: AT.REQUEST_LIST_LOADING_STARTED
		});
		CommonFetcher('/request/' + visitorTerritory, 'get', undefined, RequestsListLoadingFinished, RequestsListLoadingFailed, dispatch);
	}
}

export function RequestsListLoadingFailed(error) {
	return {
		type: AT.REQUEST_LIST_LOADING_FAILED,
		payload: {
			error
		}
	}
}

export function RequestsListLoadingFinished(requests) {
	return {
		type: AT.REQUEST_LIST_LOADING_FINISHED,
		payload: {
			requests
		}
	}
}

export function RequestsAllLoadingStarted(rsm) {
	return function (dispatch) {
		dispatch({
			type: AT.REQUEST_ALL_LIST_LOADING_STARTED
		});
		CommonFetcher('/requests/' + rsm, 'get', undefined, RequestsAllListLoadingFinished, RequestsAllListLoadingFailed, dispatch);
	}
}

export function RequestsAllListLoadingFailed(error) {
	return {
		type: AT.REQUEST_ALL_LIST_LOADING_FAILED,
		payload: {
			error
		}
	}
}

export function RequestsAllListLoadingFinished(allRequests) {
	return {
		type: AT.REQUEST_ALL_LIST_LOADING_FINISHED,
		payload: {
			allRequests
		}
	}
}

export function RequestRemovingStarted(requestId) {
	return function (dispatch) {
		dispatch({
			type: AT.REQUEST_REMOVING_STARTED
		});
		CommonFetcher('/request/' + requestId, 'delete', undefined, RequestRemovingFinished, RequestRemovingFailed, dispatch);
	}
}

export function RequestRemovingFailed(error) {
	return {
		type: AT.REQUEST_REMOVING_FAILED,
		payload: {
			error
		}
	}
}

export function RequestRemovingFinished(result) {
	return {
		type: AT.REQUEST_REMOVING_FINISHED,
		payload: {
			id: result.id, 
			license: result.license
		}
	}
}

export function RequestsSetStatusStarted(id, status) {
	return function (dispatch) {
		dispatch({
			type: AT.REQUEST_SETSTATUS_STARTED
		});
		CommonFetcher('/request/' + id + '/' + status, 'post', undefined, RequestsSetStatusFinished, RequestsSetStatusFailed, dispatch);
	}
}

export function RequestsSetStatusFailed(error) {
	return {
		type: AT.REQUEST_SETSTATUS_FAILED,
		payload: {
			error
		}
	}
}

export function RequestsSetStatusFinished(result) {
	return {
		type: AT.REQUEST_SETSTATUS_FINISHED,
		payload: {
			id: result.id,
			status: result.status
		}
	}
}

//
// Settings
//

export function SettingLoadingStarted() {
	return function (dispatch) {
		dispatch({
			type: AT.SETTING_LOADING_STARTED
		});
		CommonFetcher('/settings', 'get', undefined, SettingLoadingFinished, SettingLoadingFailed, dispatch);
	}
}

export function SettingLoadingFailed(error) {
	return {
		type: AT.SETTING_LOADING_FAILED,
		payload: {
			error
		}
	}
}

export function SettingLoadingFinished(settings) {
	return {
		type: AT.SETTING_LOADING_FINISHED,
		payload: {
			settings
		}
	}
}

export function SettingSaveStarted( key, value ) {
	return function (dispatch) {
		dispatch({
			type: AT.SETTING_SAVING_STARTED
		});
		CommonFetcher('/settings', 'post', { key, value }, SettingSaveFinished, SettingSaveFailed, dispatch);
	}
}

export function SettingSaveFailed(error) {
	return {
		type: AT.SETTING_SAVING_FAILED,
		payload: {
			error
		}
	}
}

export function SettingSaveFinished(setting) {
	return {
		type: AT.SETTING_SAVING_FINISHED,
		payload: {
			setting
		}
	}
}

//
// Daily openers
//

export function DailyOpenerListLoadingStarted(visitorName) {
	return function (dispatch) {
		dispatch({
			type: AT.DAILYOPENER_LIST_LOADING_STARTED
		});
		CommonFetcher('/roadrecord/' + visitorName, 'get', undefined, DailyOpenerListLoadingFinished, DailyOpenerListLoadingFailed, dispatch);
	}
}

export function DailyOpenerListLoadingFailed(error) {
	return {
		type: AT.DAILYOPENER_LIST_LOADING_FAILED,
		payload: {
			error
		}
	}
}

export function DailyOpenerListLoadingFinished(dailyOpeners) {
	return {
		type: AT.DAILYOPENER_LIST_LOADING_FINISHED,
		payload: {
			dailyOpeners
		}
	}
}

export function DailyOpenerSaveStarted(data) {
	return function (dispatch) {
		dispatch({
			type: AT.DAILYOPENER_SAVING_STARTED
		});
		CommonFetcher('/roadrecord/', 'post', data, DailyOpenerSaveFinished, DailyOpenerSaveFailed, dispatch);
	}
}

export function DailyOpenerSaveFailed(error) {
	return {
		type: AT.DAILYOPENER_SAVING_FAILED,
		payload: {
			error
		}
	}
}

export function DailyOpenerSaveFinished(newDailyOpener) {
	return {
		type: AT.DAILYOPENER_SAVING_FINISHED,
		payload: {
			newDailyOpener
		}
	}
}

// Panel Consent

export function PanelConsentLoadingStarted() {
	return function (dispatch) {
		dispatch({
			type: AT.PANEL_CONSENT_LOADING_STARTED
		});
		CommonFetcher('/getpanelconsent', 'get', undefined, PanelConsentLoadingFinished, PanelConsentLoadingFailed, dispatch);
	}
}

export function PanelConsentLoadingFailed(error) {
	return {
		type: AT.PANEL_CONSENT_LOADING_FAILED,
		payload: {
			error
		}
	}
}

export function PanelConsentLoadingFinished(data) {
	return {
		type: AT.PANEL_CONSENT_LOADING_FINISHED,
		payload: {
			cycleName: data
		}
	}
}

export function PanelConsentSaveStarted(visitorName, visitorId, cycle) {
	return function (dispatch) {
		dispatch({
			type: AT.PANEL_CONSENT_SAVING_STARTED
		});
		CommonFetcher('/savevisitorpanelconsent', 'post', { visitorName, visitorId, cycle }, PanelConsentSaveFinished, PanelConsentSaveFailed, dispatch);
	}
}

export function PanelConsentSaveFailed(error) {
	return {
		type: AT.PANEL_CONSENT_SAVING_FAILED,
		payload: {
			error
		}
	}
}

export function PanelConsentSaveFinished(savedConsent) {
	return {
		type: AT.PANEL_CONSENT_SAVING_FINISHED,
		payload: {
			savedConsent
		}
	}
}

export function PanelConsentCheckStarted(cycle, visitorId) {
	return function (dispatch) {
		dispatch({
			type: AT.PANEL_CONSENT_CHECK_STARTED
		});
		CommonFetcher('/visitorpanelconsent/' + cycle + '/' + visitorId, 'get', undefined, PanelConsentCheckFinished, PanelConsentCheckFailed, dispatch);
	}
}

export function PanelConsentCheckFailed(error) {
	return {
		type: AT.PANEL_CONSENT_CHECK_FAILED,
		payload: {
			error
		}
	}
}

export function PanelConsentCheckFinished(data) {
	return {
		type: AT.PANEL_CONSENT_CHECK_FINISHED,
		payload: {
			hasConsented: data.hasConsented,
			timestamp: data.timestamp
		}
	}
}